// This file is generated to hold app data arrays
import adcreativeaitrial from '../assets/adcreativeaitrial.png';
import apolloLogo from '../assets/apolloailogo.webp';
import atria1 from '../assets/atria1.webp';
import blackboxai from '../assets/blackboxai.webp';
import chatgptai from '../assets/chatgptai.jpg';
import claudeailogo from '../assets/claudeailogo.jpg';
import geminiai from '../assets/geminiai.jpg';
import consensus1 from '../assets/consensus1.jpg';
import browseai1 from '../assets/browseai1.jpg';
import musebrand from '../assets/musebrand.jpg';
import landingi1 from '../assets/landingi1.jpg';
import logome from '../assets/logome1.png';
import vistasocial from '../assets/vistasocial.jpg';
import datahawkai from '../assets/datahawkai.jpg';
import elevenlabsai from '../assets/elevenlabsai.jpg';
import snowfireai from '../assets/snowfireai.jpg';
import volzaai from '../assets/volzaai.png';
import laxisai from '../assets/laxisai.jpg';
import getresponseai from '../assets/getresponseai.jpg';
import creativescoreai from '../assets/creativescoreai.jpg';
import databoxai from '../assets/databoxai.webp';
import gammaai from '../assets/gammaai.jpg';
import warmyicon from '../assets/warmyicon.jpg';
import recomaze1 from '../assets/recomaze1.jpg';
import vida1 from '../assets/vida1.webp';
import smartli1 from '../assets/smartli1.jpg';
import preziai from '../assets/preziai.png';
import printifylogo from '../assets/printifylogo.png';
import tradify1 from '../assets/tradify1.jpg';
import thordatawebp from '../assets/thordata.webp';
import humeai from '../assets/humeai.webp';
import InVideoAvatar from '../assets/InVideoAvatar.webp';
import nanozlogo from '../assets/nanozlogo.png';
import netlifylogo from '../assets/netlifylogo.jpeg';
import tidioai from '../assets/tidioai.webp';
import webydoai from '../assets/webydoai.webp';
import seamlessailogo from '../assets/seemlessailogo.jpg';
import descriptai from '../assets/descriptai.png';
import unbounceai from '../assets/unbounceai.png';
import landbotai from '../assets/landbotai.png';
import reclaimai from '../assets/reclaimai.png';
import amplemarketai from '../assets/amplemarketai.webp';
import quillbot from '../assets/quilbot.jpg';
import seosparkplug1 from '../assets/seosparkplug1.jpg';

export const freeAppsData = [
  {
    name: "ChatGPT",
    description: "Free AI chatbot with GPT-4o mini, perfect for conversations and basic tasks",
    category: "Chat & Writing",
    features: ["Unlimited GPT-4o mini", "Web browsing", "File uploads", "Mobile app"],
    link: "https://chat.openai.com",
    image: chatgptai
  },
  {
    name: "Claude",
    description: "Anthropic's AI assistant with superior writing capabilities and 200K context",
    category: "Writing & Analysis",
    features: ["200K token context", "Superior writing", "File analysis", "Web search"],
    link: "https://claude.ai",
    image: claudeailogo
  },
  {
    name: "Google Gemini",
    description: "Google's AI model with advanced reasoning and multimodal capabilities",
    category: "Multimodal AI",
    features: ["Image analysis", "Code generation", "Creative writing", "Google integration"],
    link: "https://gemini.google.com",
    image: geminiai
  }
];

export const trialAppsData = [
  {
    name: "SEOSparkPlug",
    description: "AI-powered SEO platform that analyzes 50+ factors, writes code, optimizes social content, and tracks results in one workflow",
    category: "SEO & Digital Marketing",
    features: ["50+ factor SEO analysis", "AI Optimization engine", "Live voice AI agent (SparkPlugger)", "Copy-ready code & schema fixes", "Social media optimization", "Competitive tracking & monitoring"],
    link: "https://seosparkplug.com",
    trialInfo: "Free analysis available",
    image: seosparkplug1,
    readMoreLink: "/learn/seosparkplug"
  },
  {
    name: "Nanoz.fun",
    description: "AI-powered branding tool that simplifies the branding process with top AI tools and an organization flow for persistent brand growth",
    category: "Branding & Design",
    features: ["Top AI branding tools (agency-grade)", "Nanoz Lab brand consistency engine", "Organization workflow for persistent growth", "Smart folders & asset categorization", "Professional imagery at fraction of cost", "Scales with your brand over time"],
    link: "https://nanoz.fun",
    trialInfo: "Free Trial Available",
    image: nanozlogo,
    readMoreLink: "/learn/nanoz-complete-guide"
  },
  {
    name: "MuseIt",
    description: "AI-powered art creation platform that turns your imagination into beautiful artwork. Turn the noise into art with guided creativity and mindfulness-focused design",
    category: "Creative & Design",
    features: ["AI art generation", "Gallery ready quality", "No technical skills", "Creative assistant", "Mindfulness focused design"],
    link: "https://museit.art/?ref=BAIB",
    trialInfo: "Free Trial Available",
    image: musebrand,
    readMoreLink: "/learn/museit-art-complete-guide"
  },
  {
    name: "Landingi",
    description: "AI-powered landing page builder that creates high-converting landing pages in minutes. Build beautiful, responsive landing pages with drag-and-drop editor and AI assistance",
    category: "Marketing & Web Design",
    features: ["AI landing page builder", "Drag-and-drop editor", "High-converting templates", "A/B testing", "Lead generation"],
    link: "https://try.landingi.com/lwfc597yjm25",
    trialInfo: "Free trial available",
    image: landingi1,
    readMoreLink: "/learn/landingi-complete-guide"
  },
  {
    name: "Murf",
    description: "AI-powered text-to-speech platform that creates natural-sounding voiceovers for videos, podcasts, and presentations",
    category: "Voice & Audio AI",
    features: ["Text-to-speech voices", "Voice cloning", "Voice changer", "Multiple languages", "Studio editor"],
    link: "https://get.murf.ai/i5n7gfvz5cbw",
    trialInfo: "Free Trial Available",
    image: "/murfai.png",
    readMoreLink: "/learn/murf-ai-complete-guide"
  },
  {
    name: "Trainual",
    description: "AI-powered employee training platform that turns SOPs and processes into role-based onboarding, documentation, and instant answers for your team",
    category: "Learning & Training",
    features: ["AI training content generation", "Role-based learning paths", "SOP documentation", "AI knowledge assistant"],
    link: "https://start.trainual.com/7epsexyi89t3",
    trialInfo: "Try for free",
    image: "/trainualai.jpg",
    readMoreLink: "/learn/trainual-complete-guide"
  },
  {
    name: "Ignition",
    description: "Practice management software for accounting and bookkeeping firms—client onboarding, proposals, and payments in one platform",
    category: "Business Management",
    features: ["Proposals & engagement letters", "Client onboarding", "Online payments", "Practice management"],
    link: "https://get.practiceignition.com/BAIB",
    trialInfo: "Free Trial Available",
    image: "/ignitionlogo.jpg",
    readMoreLink: "/learn/practice-ignition"
  },
  {
    name: "Snowfire",
    description: "AI-powered website builder and e-commerce platform that helps you create beautiful, professional websites without code",
    category: "Web Design & E-commerce",
    features: ["AI website builder", "E-commerce features", "No-code design", "Marketing tools", "SEO optimization"],
    link: "https://snowfire.com/?ref=BAIB",
    trialInfo: "Free Trial Available",
    image: snowfireai,
    readMoreLink: "/learn/snowfire-ai"
  },
  {
    name: "Descript",
    description: "AI-powered video and podcast editing platform that makes editing as easy as editing text, with transcription-based editing and AI features",
    category: "Video & Audio Editing",
    features: ["Text-based video editing", "AI video generation", "Voice cloning", "Screen recording", "Automatic transcription", "AI avatars"],
    link: "https://get.descript.com/BAIB",
    trialInfo: "Free Trial Available",
    image: descriptai,
    readMoreLink: "/learn/descript"
  },
  {
    name: "Reply.io",
    description: "AI-powered sales engagement platform that automates multichannel outreach, finds qualified leads, and books meetings for sales teams",
    category: "Sales & CRM",
    features: ["Multichannel automation", "AI SDR agents", "B2B database", "Email warmup", "CRM integration"],
    link: "https://get.reply.io/ub7edypmq2gj",
    trialInfo: "14-Day Free Trial",
    image: "/replyio.png",
    readMoreLink: "/learn/reply-io-complete-guide"
  },
  {
    name: "ThorData",
    description: "AI-powered data analytics platform that helps businesses analyze, visualize, and make data-driven decisions",
    category: "Data Analytics & Business Intelligence",
    features: ["Data visualization", "Business intelligence", "Analytics dashboards", "Data integration", "Reporting tools"],
    link: "https://affiliate.thordata.com/BAIB",
    trialInfo: "Free Trial Available",
    image: thordatawebp,
    readMoreLink: "/learn/thordata"
  },
  {
    name: "AdCreative",
    description: "AI-powered ad creative generator that creates high-converting ads in seconds",
    category: "Marketing & Advertising",
    features: ["90%+ creative performance scoring", "Brand intelligence engine", "Platform-specific ad optimization", "Competitor ad intelligence", "AI product photoshoots", "Video ad creation"],
    link: "https://free-trial.adcreative.ai/BAIB",
    trialInfo: "Free Trial Available",
    image: adcreativeaitrial,
    readMoreLink: "/learn/adcreative-ai"
  },
  {
    name: "Laxis",
    description: "AI meeting assistant that records, transcribes, summarizes, and turns conversations into actionable notes",
    category: "Productivity & Meetings",
    features: ["Meeting recording", "Transcripts & summaries", "Action items", "CRM notes", "Team collaboration"],
    link: "https://get.laxis.com/BAIB",
    trialInfo: "Free Trial Available",
    image: laxisai,
    readMoreLink: "/learn/laxis"
  },
  {
    name: "Prezi AI",
    description: "AI-powered presentation platform that helps you create engaging, dynamic, and visually stunning presentations. Enhance your storytelling with Prezi's unique zoomable canvas and AI-driven design suggestions",
    category: "Presentations & Docs",
    features: ["AI presentation builder", "Zoomable canvas", "Visual storytelling", "Dynamic templates", "Collaboration tools"],
    link: "https://prezi.sjv.io/BAIB",
    trialInfo: "Start for free",
    image: preziai,
    readMoreLink: "/learn/prezi-complete-guide"
  },
  {
    name: "Logome",
    description: "AI-powered logo generator and brand kit creator",
    category: "Creative & Design",
    features: ["AI logo generator", "Brand kit creation", "Website templates", "Social media templates", "Business cards", "Email signatures", "100+ fonts", "Free logo design"],
    link: "https://logomeai.partnerlinks.io/BAIB",
    trialInfo: "Start for free",
    image: logome,
    readMoreLink: "/learn/logome-complete-guide"
  },
  {
    name: "Weave",
    description: "AI-powered communication platform for healthcare practices with AI Receptionist, call intelligence, automated reminders, payment solutions, and patient engagement tools",
    category: "Email & Communication",
    features: ["AI Receptionist (voice & text)", "Call Intelligence", "Automated appointment reminders", "Text-to-pay", "Online scheduling", "Review management", "Email marketing", "No long-term contracts"],
    link: "https://partnerstack.getweave.com/BAIB",
    trialInfo: "Free Trial Available",
    image: "/weaveai.jpg",
    readMoreLink: "/learn/weave"
  },
  {
    name: "Spiky",
    description: "Real-time AI sales coaching and meeting intelligence that surfaces winning behaviors, handles objections on the spot, and syncs with your CRM",
    category: "Sales & CRM",
    features: ["Real-time call feedback", "Playbook execution (e.g. MEDDPICC)", "Objection detection & responses", "Pipeline visibility", "CRM sync", "Personalized coaching"],
    link: "https://get.spiky.ai/BAIB",
    trialInfo: "Free Trial Available",
    image: "/spikyai.png",
    readMoreLink: "/learn/spiky-ai"
  },
  {
    name: "Volza",
    description: "Global trade intelligence platform that helps you find suppliers, analyze competitors, and track shipments across markets",
    category: "Sales & Market Intelligence",
    features: ["Supplier discovery", "Shipment tracking", "Competitor analysis", "Trade data insights", "Market research"],
    link: "https://partner.volza.com/BAIB",
    trialInfo: "Free Trial Available",
    image: volzaai,
    readMoreLink: "/learn/volza"
  },
  {
    name: "Hume AI",
    description: "Empathic AI platform that understands human emotion and expression to create more natural, engaging interactions",
    category: "AI & Machine Learning",
    features: ["Emotion recognition", "Voice AI", "Facial expression analysis", "Empathic AI models", "Real-time emotion detection"],
    link: "https://try.hume.ai/BAIB",
    trialInfo: "Free Trial Available",
    image: humeai,
    readMoreLink: "/learn/hume-ai"
  },
  {
    name: "Flowith AI",
    description: "AI-powered workflow automation platform that helps streamline your business processes",
    category: "Workflow Automation",
    features: ["AI process automation", "No-code workflows", "Integration capabilities", "Analytics dashboard"],
    link: "https://aff.flowith.io/52dtlja1b580",
    trialInfo: "Free trial available",
    image: "/flowith.jpg",
    readMoreLink: "/learn/flowith-io"
  },
  {
    name: "Adwisely",
    description: "AI-powered Google Ads & Meta Ads platform that launches full-funnel campaigns and optimizes for high ROAS with expert support",
    category: "Marketing & Advertising",
    features: ["AI-powered Google & Meta ads", "Full-funnel campaigns", "Automated optimization", "Dedicated ad expert support", "ROAS tracking"],
    link: "https://get.adwisely.com/BAIB",
    trialInfo: "7-day free trial",
    image: "/adwisely.png",
    readMoreLink: "/learn/adwisely"
  },
  {
    name: "Smartli",
    description: "AI-powered content creator that helps you write blogs, social media posts, and product descriptions faster",
    category: "Chat & Writing",
    features: ["Blog post generation", "Social media templates", "Product descriptions", "Content rewriting", "Multilingual support"],
    link: "https://smartli.partnerlinks.io/BAIB",
    trialInfo: "Free Trial Available",
    image: smartli1,
    readMoreLink: "/learn/smartli"
  },
  {
    name: "Apollo AI",
    description: "AI sales platform with over 210 million contacts to find, contact, and close your ideal buyers",
    category: "Sales & CRM",
    features: ["275M+ contact B2B database", "Intent data & buying signals", "Multi-channel sequences (email, LinkedIn, phone)", "Real-time email verification", "AI-powered personalization", "CRM integrations & analytics"],
    link: "https://get.apollo.io/BAIB",
    trialInfo: "Pro plans from $49/month",
    image: apolloLogo,
    readMoreLink: "/learn/apollo-io"
  },
  {
    name: "Landbot",
    description: "AI-powered chatbot platform that combines AI intelligence with rule-based logic to build conversational experiences for websites, WhatsApp, and more",
    category: "Chatbots & Automation",
    features: ["AI Agent Chatbots", "WhatsApp Chatbots", "Website Chatbots", "No-code builder", "Lead generation", "Customer support automation"],
    link: "https://get.landbotlab.com/BAIB",
    trialInfo: "Free plan available",
    image: landbotai,
    readMoreLink: "/learn/landbot"
  },
  {
    name: "CreativeScore",
    description: "AI creative analysis platform that scores ad creatives and predicts performance before you launch",
    category: "Marketing & Advertising",
    features: ["Creative scoring", "Performance prediction", "Ad diagnostics", "Creative optimization tips", "Team collaboration"],
    link: "https://affiliate.creativescore.ai/BAIB",
    trialInfo: "Free Trial Available",
    image: creativescoreai,
    readMoreLink: "/learn/creativescore"
  },
  {
    name: "Netlify",
    description: "Modern web hosting and deployment platform for JAMstack sites, serverless functions, and AI apps with Git-based workflows and instant preview deploys",
    category: "Web Development & Hosting",
    features: ["Deploy from Git", "Serverless functions", "Edge network", "Preview deploys", "Forms & analytics", "Free tier for developers"],
    link: "https://join.netlify.com/BAIB",
    trialInfo: "Free tier available",
    image: netlifylogo,
    readMoreLink: "/learn/netlify-complete-guide"
  },
  {
    name: "ElevenLabs",
    description: "AI voice and text-to-speech platform for realistic voiceovers, voice cloning, and multilingual audio",
    category: "Voice & Audio AI",
    features: ["Text-to-speech voices", "Voice cloning", "Dubbing and localization", "Sound effects generation", "API access"],
    link: "https://try.elevenlabs.io/BAIB",
    trialInfo: "Free Trial Available",
    image: elevenlabsai,
    readMoreLink: "/learn/elevenlabs"
  },
  {
    name: "VEED",
    description: "AI-powered video editing platform that makes it easy to create, edit, and enhance videos with professional tools",
    category: "Video Creation & Editing",
    features: ["AI video editing", "Subtitle generation", "Screen recording", "Video templates", "Collaboration tools"],
    link: "https://veed.cello.so/2KWVFnsJmFA",
    trialInfo: "Free Trial Available",
    image: "/veedreview.png",
    readMoreLink: "/learn/veed-complete-guide"
  },
  {
    name: "Tidio",
    description: "AI-powered customer service platform that combines live chat, chatbots, and email marketing to grow your business. Enhance customer engagement with Tidio's Lyro AI assistant",
    category: "Customer Support & Engagement",
    features: ["AI customer service", "Live chat & chatbots", "Email marketing", "Multichannel support", "Analytics & reporting"],
    link: "https://tidio.partnerlinks.io/BAIB",
    trialInfo: "Start for free",
    image: tidioai,
    readMoreLink: "/learn/tidio-ai"
  },
  {
    name: "MeetGeek",
    description: "AI meeting notetaker that records, transcribes, and summarizes Zoom, Teams, and Google Meet calls with workflows, analytics, and 50+ language support",
    category: "Productivity & Collaboration",
    features: ["Auto meeting recording", "AI transcription & summaries", "Action items & highlights", "Zoom, Teams & Google Meet", "Slack, Notion & CRM sync", "Mobile offline recording"],
    link: "https://get.meetgeek.ai/BAIB",
    trialInfo: "Free plan available",
    image: "/meetgeeklogo.png",
    readMoreLink: "/learn/meetgeek-complete-guide"
  },
  {
    name: "Atria",
    description: "The AI ad engine that grows your revenue with analytics, research, creation, and inspiration tools all in one platform",
    category: "Marketing & Advertising",
    features: ["AI ad analytics", "25M+ ad library", "AI ad creation", "Competitor research", "Asset management"],
    link: "https://affiliates.tryatria.com/BAIB",
    trialInfo: "7-Day Free Trial",
    image: atria1,
    readMoreLink: "/learn/atria"
  },
  {
    name: "Databox",
    description: "Business analytics platform that connects data from 130+ sources, builds custom metrics, and creates no-code dashboards to visualize and report on key performance indicators",
    category: "Business Analytics & Data Visualization",
    features: ["130+ data integrations", "Custom metrics builder", "No-code dashboards", "Automated reporting", "Goal tracking", "AI performance summaries"],
    link: "https://join.databox.com/BAIB",
    trialInfo: "Free Trial Available",
    image: databoxai,
    readMoreLink: "/learn/databox"
  },
  {
    name: "Miro",
    description: "Online collaborative whiteboard platform for teams to brainstorm, plan, and work together visually",
    category: "Productivity & Collaboration",
    features: ["Visual collaboration", "Whiteboard tools", "Team templates", "Real-time editing", "Integrations"],
    link: "https://ps.miro-affiliate.com/gwnvu4zj3r8r",
    trialInfo: "Free Trial Available",
    image: "/miro.png",
    readMoreLink: "/learn/miro-complete-guide"
  },
  {
    name: "Reclaim",
    description: "AI-powered calendar and time management platform that automatically schedules meetings, blocks focus time, and optimizes your calendar for productivity",
    category: "Productivity & Time Management",
    features: ["Smart scheduling", "Automatic calendar blocking", "Focus time protection", "Meeting optimization", "Calendar analytics", "Team scheduling"],
    link: "https://go.reclaim.ai/BAIB",
    trialInfo: "Free plan available",
    image: reclaimai,
    readMoreLink: "/learn/reclaim-ai"
  },
  {
    name: "Consensus",
    description: "AI-powered research tool that finds and synthesizes evidence from scientific papers and academic literature",
    category: "Research & Education",
    features: ["AI research synthesis", "Academic paper search", "Evidence-based answers", "Citation management"],
    link: "https://get.consensus.app/BAIB",
    trialInfo: "Free trial available",
    image: consensus1,
    readMoreLink: "/learn/consensus"
  },
  {
    name: "Amplemarket",
    description: "AI-powered sales engagement platform that combines prospecting, outreach, and automation to help sales teams find, contact, and close more deals",
    category: "Sales & CRM",
    features: ["AI prospecting", "Multichannel outreach", "Email warmup", "CRM integration", "Bounce rates under 2.3%", "25%+ reply rates"],
    link: "https://grow.amplemarket.com/BAIB",
    trialInfo: "Free Trial Available",
    image: amplemarketai,
    readMoreLink: "/learn/amplemarket"
  },
  {
    name: "Unbounce",
    description: "AI-powered landing page builder and conversion optimization platform that helps marketers build, test, and optimize landing pages without code",
    category: "Marketing & Landing Pages",
    features: ["Drag-and-drop builder", "A/B testing", "AI copywriting", "Smart Traffic optimization", "100+ templates", "1,000+ integrations"],
    link: "https://unbounce.partnerlinks.io/BAIB",
    trialInfo: "14-day free trial",
    image: unbounceai,
    readMoreLink: "/learn/unbounce"
  },
  {
    name: "Capsule CRM",
    description: "Simple CRM for small businesses to manage contacts, sales pipeline, and customer relationships",
    category: "Sales & CRM",
    features: ["Contact management", "Email marketing", "Project management", "Workflow automation"],
    link: "https://get.capsulenow.io/BAIB",
    trialInfo: "14-day free trial",
    image: "/capsulecrm.png",
    readMoreLink: "/learn/capsule-crm-complete-guide"
  },
  {
    name: "Lindy",
    description: "AI-powered personal assistant that helps you manage tasks",
    category: "Productivity & Personal Assistant",
    features: ["Task management", "Smart scheduling", "Email organization", "Meeting assistance"],
    link: "https://try.lindy.ai/lhgvxfidor04",
    trialInfo: "Free Trial Available",
    image: "/lindy.png",
    readMoreLink: "/learn/lindy-ai"
  },
  {
    name: "Gamma",
    description: "AI-powered presentation and document builder that turns prompts into polished decks, docs, and webpages",
    category: "Presentations & Docs",
    features: ["AI slide generation", "Presentation templates", "Brand themes", "One-click export", "Web publish links"],
    link: "https://try.gamma.app/BAIB",
    trialInfo: "Free Trial Available",
    image: gammaai,
    readMoreLink: "/learn/gamma"
  },
  {
    name: "Vida",
    description: "The all-in-one AI platform for creators and businesses to build, share, and monetize their work",
    category: "Content Creation & Monetization",
    features: ["AI content generation", "Monetization tools", "Creator community", "Brand management", "Analytics"],
    link: "https://vida.sjv.io/BAIB",
    trialInfo: "Free Trial Available",
    image: vida1,
    readMoreLink: "/learn/vida-ai-agent-os"
  },
  {
    name: "Warmy",
    description: "Auto All-In-One Tool For Email Deliverability To Make Your Email Channel Reliable",
    category: "Email Marketing",
    features: ["AI assistant Adeline warm-up", "250,000+ domain network", "Real-time blacklist monitoring", "Multi-domain dashboard", "Industry-specific warm-up emails", "Mailbox temperature analytics"],
    link: "https://warmyio.partnerlinks.io/ffy5y6ll9374",
    trialInfo: "7-Day Free Trial",
    image: warmyicon,
    readMoreLink: "/news/warmy-io-spam-folder-rebellion-email-deliverability"
  },
  {
    name: "Tradify",
    description: "All-in-one job management software for tradespeople to manage quotes, invoices, and scheduling",
    category: "Business Management",
    features: ["Job scheduling", "Quoting & invoicing", "Timesheet management", "Subcontractor management", "GPS tracking"],
    link: "https://tradify.sjv.io/BAIB",
    trialInfo: "14-day free trial",
    image: tradify1,
    readMoreLink: "/learn/tradify-complete-guide"
  },
  {
    name: "Emergent",
    description: "Build full-stack web and mobile apps in minutes through conversation with AI agents that design, code, and deploy",
    category: "Development & Coding",
    features: ["Conversation-to-app", "AI design & code", "Web & mobile", "Deploy from chat", "Y Combinator S24"],
    link: "https://get.emergent.sh/BAIB",
    trialInfo: "Free Trial Available",
    image: "/emergentai.png",
    readMoreLink: "/learn/emergent"
  },
  {
    name: "Brevo",
    description: "AI-driven email marketing platform trusted by 500,000+ companies with automation and smart segmentation",
    category: "Email Marketing & Automation",
    features: ["Smart segmentation", "Send time optimization", "Automation workflows", "150+ integrations"],
    link: "https://get.brevo.com/um9xszmf3nfd",
    trialInfo: "Free plan available",
    image: "/brevologo.png",
    readMoreLink: "/learn/brevo-complete-guide"
  },
  {
    name: "Invideo",
    description: "AI video creation platform with thousands of templates and easy editing",
    category: "Video Creation",
    features: ["AI video generation", "5000+ templates", "Text-to-video", "Easy editing"],
    link: "https://betteraibots.com/invideo",
    trialInfo: "Free Trial Available",
    image: InVideoAvatar,
    readMoreLink: "/learn/invideo-ai"
  },
  {
    name: "Browse AI",
    description: "AI-powered web scraping and monitoring platform that extracts data from any website with no coding required",
    category: "Data Extraction & Web Scraping",
    features: ["No-code web scraping", "Website monitoring", "API generation", "7,000+ integrations"],
    link: "https://partners.browse.ai/BAIB",
    trialInfo: "Free trial available",
    image: browseai1,
    readMoreLink: "/learn/browse-ai"
  },
  {
    name: "Recomaze",
    description: "Personalized AI product recommendations for e-commerce stores to increase average order value and conversion rates",
    category: "E-commerce & Personalization",
    features: ["Smart product recommendations", "Upsell and cross-sell", "Automated campaigns", "A/B testing", "Analytics dashboard"],
    link: "https://recomaze.com/?ref=BAIB",
    trialInfo: "Free Trial Available",
    image: recomaze1,
    readMoreLink: "/learn/recomaze"
  },
  {
    name: "ActiveCampaign",
    description: "AI-powered email marketing, marketing automation, and CRM platform with visual workflows, lead scoring, and 900+ integrations",
    category: "Email Marketing & Automation",
    features: ["Visual automation builder", "Built-in CRM & pipelines", "Lead scoring", "Predictive sending", "Landing pages & forms", "Active Intelligence AI"],
    link: "https://try.activecampaign.com/q84v43xjanzq",
    trialInfo: "14-day free trial",
    image: "/activecampaign.webp",
    readMoreLink: "/learn/activecampaign"
  },
  {
    name: "Travel Code AI",
    description: "AI travel planning platform that builds trip plans, routes, and day-by-day itineraries from your preferences and budget",
    category: "Travel & Planning",
    features: ["AI trip planning", "Day-by-day itineraries", "Route optimization", "Budget-aware recommendations", "Shareable plans"],
    link: "https://join.travel-code.com/BAIB",
    trialInfo: "Free Trial Available",
    image: "/travelcodeai.jpg",
    readMoreLink: "/learn/travel-code-ai-complete-guide"
  },
  {
    name: "Alli AI",
    description: "AI-powered SEO automation platform that optimizes, automates, and scales SEO campaigns without coding",
    category: "SEO & Marketing",
    features: ["Instant on-page SEO deployment", "Bulk optimization at scale", "Works with any CMS", "Live SEO browser extension", "Site speed optimization (up to 80%)", "No coding required"],
    link: "https://try.alliai.com/0guepbqpqhsf",
    trialInfo: "10-Day Free Trial",
    image: "https://betteraibots.com/alliai.png",
    readMoreLink: "/learn/alli-ai"
  },
  {
    name: "QuillBot",
    description: "AI-powered writing assistant that helps you paraphrase, check grammar, detect AI content, and improve your writing. Write effortlessly and efficiently with QuillBot's suite of AI tools",
    category: "Writing & Editing",
    features: ["AI paraphrasing tool", "Grammar checker", "AI detector", "Plagiarism checker", "AI humanizer", "Summarizer", "Citation generator"],
    link: "https://try.quillbot.com/BAIB",
    trialInfo: "Free plan available",
    image: quillbot,
    readMoreLink: "/learn/quillbot-complete-guide"
  },
  {
    name: "Blackbox",
    description: "AI-powered code assistant that helps developers write code faster with real-time autocomplete and intelligent suggestions",
    category: "Development & Coding",
    features: ["AI code completion", "Multi-language support", "Context-aware suggestions", "Real-time autocomplete"],
    link: "https://blackboxai.partnerlinks.io/BAIB",
    trialInfo: "Free Trial Available",
    image: blackboxai,
    readMoreLink: "/learn/blackbox-ai"
  },
  {
    name: "Beautiful.ai",
    description: "AI presentation software with Smart Slides, Create with AI workflow, brand controls, and team collaboration for work-ready decks 10x faster",
    category: "Presentations & Docs",
    features: ["Create with AI workflow", "Smart Slides auto-layout", "Brand themes & locked slides", "PowerPoint export"],
    link: "https://beautifulai.partnerlinks.io/mf21oqg4umdr",
    trialInfo: "14-day free trial",
    image: "/beautifulai.jpg",
    readMoreLink: "/learn/beautiful-ai-complete-guide"
  },
  {
    name: "Wispr Flow",
    description: "Voice-first AI assistant for faster typing, note-taking, and content creation across all your apps",
    category: "Productivity & Voice AI",
    features: ["Voice dictation", "Cross-platform compatibility", "AI-powered transcription", "Background operation"],
    link: "https://wisprflow.ai/downloads?referral=KING16",
    trialInfo: "Free trial available",
    image: "https://betteraibots.com/wispr.png",
    readMoreLink: "/learn/wispr-flow-complete-guide"
  },
  {
    name: "Lusha",
    description: "B2B contact data platform that helps sales teams find accurate contact information for prospects and build targeted lists",
    category: "Sales & CRM",
    features: ["Email finder", "Phone number lookup", "Company intelligence", "CRM integration", "Browser extension"],
    link: "https://partnerstack.lusha.com/w61xn76pa3sr",
    trialInfo: "Free Trial Available",
    image: "/lusha1.jpg",
    readMoreLink: "/learn/lusha"
  },
  {
    name: "Close",
    description: "Sales CRM built for inside sales teams with built-in calling, email sequences, SMS, and pipeline management in one inbox",
    category: "Sales & CRM",
    features: ["Built-in power dialer", "Email & SMS sequences", "Pipeline management", "Sales reporting"],
    link: "https://refer.close.com/x04k0vvgqte4",
    trialInfo: "14-day free trial",
    image: "/closeailogo.png",
    readMoreLink: "/learn/close-complete-guide"
  },
  {
    name: "MRPeasy",
    description: "Cloud-based manufacturing ERP system designed for small and medium-sized manufacturers to manage production, inventory, and operations",
    category: "Business Management",
    features: ["Production planning", "Inventory management", "Shop floor control", "Quality control", "Reporting & analytics"],
    link: "https://try.mrpeasy.com/m72w6bztymwh",
    trialInfo: "Free Trial Available",
    image: "/mrpeasy.png",
    readMoreLink: "/learn/mrpeasy-complete-guide"
  },
  {
    name: "DataHawk",
    description: "Amazon marketplace analytics and keyword tracking platform for sellers and brands who want to grow rankings, revenue, and market share",
    category: "E-commerce & Marketplace Analytics",
    features: ["Keyword rank tracking", "Market intelligence", "Sales & profitability analytics", "PPC insights", "Competitor monitoring"],
    link: "https://get.datahawk.co/eoe07kko8pol",
    trialInfo: "Free Trial Available",
    image: datahawkai,
    readMoreLink: "/learn/datahawk"
  },
  {
    name: "Turbotic",
    description: "AI-powered automation and transformation platform for building business cases, automating workflows, and deploying digital transformation with secure, compliant tools",
    category: "AI & Development",
    features: ["Custom AI assistants", "Meeting Agent for summaries", "Business case generation", "Process documentation", "Automation roadmaps", "ISO-27001 & SOC 2 compliant", "Free trial available"],
    link: "https://try.turbotic.com/BAIB",
    trialInfo: "Free Trial Available",
    image: "/turbotic.webp",
    readMoreLink: "/learn/turbotic"
  },
  {
    name: "GetResponse",
    description: "Email marketing and automation platform with campaigns, landing pages, and conversion funnels",
    category: "Email Marketing & Automation",
    features: ["Email campaigns", "Marketing automation", "Landing pages", "Funnels", "Contact segmentation"],
    link: "https://try.getresponsetoday.com/BAIB",
    trialInfo: "Free Trial Available",
    image: getresponseai,
    readMoreLink: "/learn/getresponse"
  },
  {
    name: "Pinecone",
    description: "Vector database for semantic search, RAG, and AI apps with fully managed infrastructure and serverless scaling",
    category: "AI & Machine Learning",
    features: ["Serverless auto-scaling infrastructure", "Production-ready RAG integration", "Hybrid semantic + keyword search", "Namespaces & metadata filters", "Sub-100ms query latency", "Built for AI agents & recommendations"],
    link: "https://www.skowers.com/api/go/d8",
    trialInfo: "Free tier available",
    image: "/pineconeai.jpg",
    readMoreLink: "/learn/pinecone-vector-database"
  },
  {
    name: "Printify",
    description: "Leading print-on-demand platform to create and sell custom products with 1300+ items, global fulfillment, and integrations for Shopify, Etsy, TikTok, and Amazon",
    category: "E-commerce & Print on Demand",
    features: ["1300+ custom products", "No upfront inventory", "Global fulfillment network", "Shopify & Etsy integrations", "Mockup generator", "AI image generator"],
    link: "https://try.printify.com/BAIB",
    trialInfo: "100% free to start",
    image: printifylogo,
    readMoreLink: "/learn/printify-complete-guide"
  },
  {
    name: "GoHighLevel",
    description: "AI-powered all-in-one business operating system for marketing, sales, and client management with automation, CRM, and white-label capabilities",
    category: "Business Management",
    features: ["All-in-one platform", "CRM & pipeline management", "Social media scheduling", "Landing pages & funnels", "White-label solution", "AI-powered automation", "14-day free trial"],
    link: "https://www.gohighlevel.com/?fp_ref=baib",
    trialInfo: "14-Day Free Trial",
    image: "/gohighlevelai.jpg",
    readMoreLink: "/learn/gohighlevel"
  },
  {
    name: "Vista Social",
    description: "The most advanced all-in-one social media management platform for brands and agencies",
    category: "Marketing & Advertising",
    features: ["Social media scheduling", "AI content generation", "Social listening", "Analytics & reporting", "Review management"],
    link: "https://vistasocial.sjv.io/BAIB",
    trialInfo: "14-day free trial",
    image: vistasocial,
    readMoreLink: "/learn/vista-social"
  },
  {
    name: "SleekFlow",
    description: "Omnichannel AI messaging platform that centralizes WhatsApp, Messenger, and live chat in one inbox with AI agents for lead qualification and conversion",
    category: "Chatbots & Automation",
    features: ["Shared team inbox", "WhatsApp Business API", "AI agents (AgentFlow)", "Broadcast campaigns", "CRM integrations", "Catalog & payment in chat"],
    link: "https://sleekflow.partnerlinks.io/BAIB",
    trialInfo: "Start for Free",
    image: "/sleekflowai.jpg",
    readMoreLink: "/learn/sleekflow"
  },
  {
    name: "Webydo",
    description: "Professional web design platform that lets you create pixel-perfect websites without coding, with built-in CMS and client management",
    category: "Web Design & Development",
    features: ["No-code design", "Built-in CMS", "Client management", "Secure hosting"],
    link: "https://partners.webydo.com/BAIB",
    trialInfo: "Free Trial Available",
    image: webydoai,
    readMoreLink: "/learn/webydo"
  },
  {
    name: "Seamless",
    description: "Real-time B2B sales intelligence platform with 1.3+ billion contacts and 121+ million companies. Find accurate email addresses, phone numbers, and company data in seconds",
    category: "Sales & CRM",
    features: ["Real-time contact search", "1.3B+ business contacts", "121M+ companies", "Email & phone finder", "Chrome extension", "CRM integrations"],
    link: "https://get.seamless.ai/BAIB",
    trialInfo: "Free for up to 50 credits",
    image: seamlessailogo,
    readMoreLink: "/learn/seamless-ai-complete-guide"
  },
  {
    name: "ElevateForward",
    description: "AI strategy and execution platform that connects business diagnostics, strategy design, and initiative tracking in one system for growing businesses",
    category: "Business Strategy",
    features: ["Elevate Insight Reports", "Elevate Studio strategy hub", "KPI & initiative tracking", "90-day roadmap builder", "Cross-report intelligence", "Team alignment tools"],
    link: "https://partners.elevateforward.ai/iy1986n6gbz4",
    trialInfo: "Try for Free",
    image: "/elevateforward.webp",
    readMoreLink: "/learn/elevate-forward"
  }
];

